import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../../hooks/useTheme.js";

// Top-right control. The shared portal header used to own the theme switch;
// this page suppresses that header, so the switch lives here instead — same
// pill switch as Header.jsx, rendered as a real button so it is keyboard
// reachable and announces its state.
const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
      className="relative w-12 h-6 rounded-full cursor-pointer bg-gradient-to-r from-gray-200 to-gray-300 dark:from-slate-700 dark:to-slate-900 transition-all"
    >
      <span
        className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white flex items-center justify-center transition-all duration-300 ${
          isDark ? "translate-x-6 rotate-180" : "translate-x-0 rotate-0"
        }`}
      >
        {isDark ? (
          <Moon className="w-3 h-3 text-slate-700" />
        ) : (
          <Sun className="w-3 h-3 text-yellow-500" />
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
